import axios, { AxiosInstance } from "axios";
import { setupCommonInterceptors } from "./interceptors/commonInterceptors";

export type BaseHttpOptions = {
  baseURL: string;
  withCredentials?: boolean; // cookie-based auth
  defaultHeaders?: Record<string, string>;
  timeout?: number;
};

export const createBaseHttp = (opts: BaseHttpOptions): AxiosInstance => {
  // console.log("opts",opts);

  const instance = axios.create({
    baseURL: opts.baseURL,
    // timeout: opts.timeout ?? 20000,
    withCredentials: opts.withCredentials ?? true,
    headers: {
      "Content-Type": "application/json",
      ...(opts.defaultHeaders ?? {}),
    },
  });

  // Attach common interceptors (logging, token injection, retry hooks, error normalizer)
  setupCommonInterceptors(instance);

  return instance;
};

// import axios, { AxiosInstance } from "axios";

// export const createHttp = (baseURL: string): AxiosInstance => {
//     return axios.create({
//         baseURL,
//         withCredentials: true,
//         headers: {
//             "Content-Type": "application/json",
//         },
//     });
// };
